import Rails from "@rails/ujs";  // Импортируем UJS
Rails.start();  // Запуск UJS
window.Rails = Rails;  // Регистрируем Rails глобально
import 'bootstrap';
import "../stylesheets/application.scss";

import { Tooltip, Popover } from 'bootstrap';
// Импортируем jQuery (нужен для работы DataTables)
import $ from 'jquery';

// Импортируем DataTables и его стили
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';

// Убедитесь, что jQuery доступен глобально
window.$ = $;
window.jQuery = $;

// Функция для отображения всплывающего сообщения
function showFlashMessage(message, type = 'success') {
  const flashMessageElement = document.getElementById('flash-message');
  const flashTextElement = document.getElementById('flash-text');
  flashTextElement.textContent = message;
  flashMessageElement.className = `alert alert-${type} alert-dismissible fade show`;
  flashMessageElement.style.display = 'block';

  setTimeout(() => {
    flashMessageElement.classList.remove('show');
    setTimeout(() => {
      flashMessageElement.style.display = 'none';
    }, 150);
  }, 3000);
};
  

document.addEventListener('DOMContentLoaded', () => {
 const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
  
  popoverTriggerList.forEach(popoverTriggerEl => {
    const popover = new Popover(popoverTriggerEl, {
      html: true,  // Разрешаем HTML-контент
      trigger: 'manual'  // Отключаем автоматическое отображение при наведении или фокусе
    });

    // Показ Popover при клике и установка таймера для скрытия
    popoverTriggerEl.addEventListener('click', () => {
      popover.show();

      // Скрываем Popover через 5 секунд
      setTimeout(() => {
        popover.hide();
      }, 5000);
    });
  });

  // Инициализация DataTables
  const mainTable = $('#spare_parts_table').DataTable({
    paging: true,          // Включить пагинацию
    searching: true,       // Включить поиск
    ordering: true,        // Включить сортировку
    info: true,            // Включить информацию о количестве элементов
    autoWidth: false,      // Отключить автоматическую ширину колонок
    pageLength: 10,        // Количество строк на странице
    columnDefs: [
      { width: "150px", targets: 1 }, // Задаем фиксированную ширину для третьего столбца
      { width: "200px", targets: 2 }  // Задаем фиксированную ширину для третьего столбца
    ],
    fixedColumns: true, // Включаем фиксированные столбцы (если нужно)
    language: {
      url: '/dataTables/Russian.json'  // Путь к файлу локализации
    },
  });
  


// Обработчик для кнопок уменьшения
  document.querySelectorAll('.decrement-btn').forEach(function(button) {
    button.addEventListener('click', function() {
      const sparePartId = this.getAttribute('data-id'); // Получаем ID запчасти
      const quantityInput = document.querySelector(`.quantity-input[data-item-id="${sparePartId}"]`);
 
      let currentValue = parseInt(quantityInput.value, 10);
      if (currentValue > 1) {
        quantityInput.value = currentValue - 1;
      }

      if (quantityInput.classList.contains('order-quantity-input')) {
        changeOrder(sparePartId, quantityInput.value)
      }
    });
  });

  // Обработчик для кнопок увеличения
  document.querySelectorAll('.increment-btn').forEach(function(button) {
    button.addEventListener('click', function() {
      const sparePartId = this.getAttribute('data-id'); // Получаем ID запчасти
      const quantityInput = document.querySelector(`.quantity-input[data-item-id="${sparePartId}"]`);
      let currentValue = parseInt(quantityInput.value, 10);
      quantityInput.value = currentValue + 1;

      if (quantityInput.classList.contains('order-quantity-input')) {
        changeOrder(sparePartId, quantityInput.value)
      }
    });
  });

  // Обработчик для кнопок удаления
  document.querySelectorAll('.delete-btn').forEach(function(button) {
    button.addEventListener('click', function() {
      const sparePartId = this.getAttribute('data-item-id'); // Получаем ID запчасти
       // Находим строку таблицы по id
      const row = document.querySelector(`#row-${sparePartId}`);

      // Удаляем строку из DOM
      if (row) {
        row.remove();
      }

      changeOrder(sparePartId, 0)
    });
  });

  function changeOrder(id, quantity){
    console.log('we are in change oredr',id, quantity)

    let ajax_url = '/orders/update_item'
    let ajax_type = 'PATCH'

    if (quantity === 0) {
      ajax_url = '/orders/remove_item'
      ajax_type = 'DELETE'
    }
    Rails.ajax({
      url: ajax_url,  // Путь к экшену обновления
      type: ajax_type,
      contentType: 'application/json',  // Указываем, что данные в формате JSON
      dataType: 'json', // Ожидаем ответ в формате JSON
      data: new URLSearchParams({ spare_part_id: id, quantity: quantity }).toString(),  // Данные запроса
      success: function(response) {
        console.log(response.order_total_price, response.item_total_price)
        // Обновляем отображение общей стоимости позиции и заказа
        $('#order-total-price').text(response.order_total_price);
        $(`#item-total-${id}`).text(response.item_total_price);
        showFlashMessage('Заказ успешно обновлен.', 'success');
      },
      error: function(xhr) {
        alert('Ошибка при обновлении количества. Пожалуйста, попробуйте снова.');
      }
    });
  }
    const orderForm = document.getElementById('order-form');
    const emailField = document.getElementById('email');
    const phoneField = document.getElementById('phone');
    const submitButton = document.getElementById('submit-button');

    // Функция для проверки валидности полей и активации/деактивации кнопки
    function validateFields() {
      const email = emailField.value.trim();
      const phone = phoneField.value.trim();
      let isValid = true;

      // Проверяем, что хотя бы одно из полей заполнено
      if (!email && !phone) {
        isValid = false;
      }

      // Проверка на валидность email (если заполнен)
      if (email && !validateEmail(email)) {
        isValid = false;
      }

      // Включаем или отключаем кнопку отправки в зависимости от валидности
      submitButton.disabled = !isValid;
    }

    // Слушаем события ввода на полях email и phone
    emailField.addEventListener('input', validateFields);
    phoneField.addEventListener('input', validateFields);

    // Первоначальная проверка
    validateFields();

    // Обработчик события submit
    orderForm.addEventListener('submit', function(event) {
      const email = emailField.value.trim();
      const phone = phoneField.value.trim();

      // Если оба поля пусты или email не валиден, предотвращаем отправку формы
      if ((!email && !phone) || (email && !validateEmail(email))) {
        event.preventDefault();
        alert('Пожалуйста, заполните корректно либо Email, либо Номер телефона.');
      }
    });

    // Функция для проверки валидности email
    function validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    }
});
